import { IoMdTrendingUp } from "react-icons/io";
import colors from "core/resources/theme/colors";
import DashboardCard from "ui/components/Cards/DashboardCard";
import { useTotalMoradores } from "core/features/dashboards/hooks/useTotalMoradores";
import { useDashboardPrincipal } from "core/features/dashboards/store";

function CardQuantidade() {
  const { query } = useDashboardPrincipal();
  const { data, isFetching } = useTotalMoradores(query);

  return (
    <DashboardCard
      isLoading={isFetching}
      positive={true}
      bg={colors.lightGray}
      label="Quantidade de Transações"
      valuePercent={null}
      value={data?.total ?? 0}
      icon={<IoMdTrendingUp fontSize="32px" color={colors.darkGray} />}
    />
  );
}

export default CardQuantidade;
